import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    authorizedUser: false,
    defaultCompany:{"id":103,"name":"Concept1"},
    defaultAccount:{"id":5,"name":"FUL"},
    
    administrator:false,
    userInfo:{}
  },
  mutations: {
    SET_AUTHORIZED_USER(state,payload){
      state.authorizedUser = payload
    },
    SET_DEFAULT_COMPANY(state,payload) {
      state.defaultCompany = payload;
    },
    SET_DEFAULT_ACCOUNT(state,payload) {
      state.defaultAccount = payload;
    },
    
    SET_ADMINISTRATOR(state,payload) {
      state.administrator=payload
    },
    SET_USER_INFO(state,payload) {
      state.userInfo = payload
    }
  },
  getters: {
    userInfo(state) {
      return state.userInfo;
    },
    authorizedUser(state) {
      return state.authorizedUser;
    },
    defaultCompany(state) {
      console.log(state.defaultCompany)
      return state.defaultCompany
    },
    defaultAccount(state) {
      console.log(state.defaultAccount)
      return state.defaultAccount
    },
    administrator(state) {
      return state.administrator
    }
  },
  actions: {

  }
})